var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.currentComponent)?_c('div',{staticClass:"totalizers-ports"},[_c(_vm.currentComponent,{ref:"TotalizersPortsComponent",tag:"component",attrs:{"filters":_vm.filters,"portId":_vm.portId}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }